/**
 * Recharge Override - Prevents Recharge from interfering with variant selection
 * This script specifically targets the Recharge app's cart update mechanism
 */

(function() {
  'use strict';
  
  console.log('Recharge Override: Initializing');
  
  // Wait for Recharge to load
  function waitForRecharge() {
    if (window.Recharge || document.querySelector('[data-recharge]')) {
      console.log('Recharge detected, applying overrides');
      applyRechargeOverrides();
    } else {
      setTimeout(waitForRecharge, 100);
    }
  }
  
  function applyRechargeOverrides() {
    // Override Recharge's cart update mechanism
    if (window.Recharge && window.Recharge.Cart) {
      const originalUpdateCart = window.Recharge.Cart.updateCart;
      if (originalUpdateCart) {
        window.Recharge.Cart.updateCart = function(data, callback) {
          console.log('Recharge Override: Intercepting cart update');
          console.log('Recharge Override: original data:', data);
          
          // Ensure correct variant ID is used
          if (data && data.items && data.items.length > 0) {
            const activeForm = document.querySelector('form[action*="/cart/add"]');
            if (activeForm) {
              const variantPicker = activeForm.closest('product-form-component')?.querySelector('variant-picker');
              if (variantPicker) {
                const selectedOption = variantPicker.querySelector('input:checked, select option:checked');
                if (selectedOption?.dataset.variantId) {
                  console.log('Recharge Override: updating variant ID from', data.items[0].variant_id, 'to', selectedOption.dataset.variantId);
                  data.items[0].variant_id = selectedOption.dataset.variantId;
                }
              }
            }
          }
          
          console.log('Recharge Override: updated data:', data);
          return originalUpdateCart.call(this, data, callback);
        };
      }
    }
    
    // Also override any global Recharge cart functions
    if (window.Recharge && window.Recharge.cart) {
      const originalAddToCart = window.Recharge.cart.addToCart;
      if (originalAddToCart) {
        window.Recharge.cart.addToCart = function(variantId, quantity, properties) {
          console.log('Recharge Override: Intercepting addToCart');
          
          // Get the correct variant ID from the picker
          const activeForm = document.querySelector('form[action*="/cart/add"]');
          if (activeForm) {
            const variantPicker = activeForm.closest('product-form-component')?.querySelector('variant-picker');
            if (variantPicker) {
              const selectedOption = variantPicker.querySelector('input:checked, select option:checked');
              if (selectedOption?.dataset.variantId) {
                console.log('Recharge Override: using correct variant ID:', selectedOption.dataset.variantId);
                variantId = selectedOption.dataset.variantId;
              }
            }
          }
          
          return originalAddToCart.call(this, variantId, quantity, properties);
        };
      }
    }
    
    // Override any Recharge event listeners that might interfere
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function(type, listener, options) {
      if (type === 'cart:updated' || type === 'cart:change') {
        console.log('Recharge Override: Intercepting cart event listener:', type);
        return originalAddEventListener.call(this, type, function(event) {
          // Ensure the event includes correct variant information
          if (event.detail && event.detail.items) {
            const activeForm = document.querySelector('form[action*="/cart/add"]');
            if (activeForm) {
              const variantPicker = activeForm.closest('product-form-component')?.querySelector('variant-picker');
              if (variantPicker) {
                const selectedOption = variantPicker.querySelector('input:checked, select option:checked');
                if (selectedOption?.dataset.variantId && event.detail.items[0]) {
                  console.log('Recharge Override: updating cart event variant ID');
                  event.detail.items[0].variant_id = selectedOption.dataset.variantId;
                }
              }
            }
          }
          
          if (typeof listener === 'function') {
            listener.call(this, event);
          }
        }, options);
      }
      
      return originalAddEventListener.call(this, type, listener, options);
    };
    
    // Monitor for any cart updates and ensure correct variant
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          // Check if this is a cart update
          const cartElements = document.querySelectorAll('[data-cart], .cart, #cart');
          cartElements.forEach(function(cartElement) {
            if (cartElement.textContent.includes('item') || cartElement.textContent.includes('cart')) {
              console.log('Recharge Override: cart update detected, ensuring correct variant');
              
              // Force update the variant ID in any active forms
              const activeForm = document.querySelector('form[action*="/cart/add"]');
              if (activeForm) {
                const variantIdInput = activeForm.querySelector('input[name="id"]');
                const variantPicker = activeForm.closest('product-form-component')?.querySelector('variant-picker');
                
                if (variantIdInput && variantPicker) {
                  const selectedOption = variantPicker.querySelector('input:checked, select option:checked');
                  if (selectedOption?.dataset.variantId && variantIdInput.value !== selectedOption.dataset.variantId) {
                    console.log('Recharge Override: correcting variant ID in form');
                    variantIdInput.value = selectedOption.dataset.variantId;
                  }
                }
              }
            }
          });
        }
      });
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cart', 'class']
    });
    
    console.log('Recharge Override: applied successfully');
  }
  
  // Start monitoring for Recharge
  waitForRecharge();
  
})();
